import { translations } from '@tools/translations/translations';
import UserAuth from '@tools/user/auth';

/**
 * Display banners
 */

const SCROLL_MARGIN_BASE = 119;

const isMobileOrTablet = () => window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet;

/**
 * "Edit offer" section has a custom menu
 * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-4803
 */
const adjustEditOffer = () => {
  const editOfferHeader = document.getElementsByClassName('edit-offer-navigation')[0];

  if (editOfferHeader && window.BREAKPOINTS.isDesktop) {
    const backMyOffersLink = document.getElementsByClassName('edit-offer-title__offers-link')[0];
    if (document.getElementById('banner')) {
      backMyOffersLink.classList.add('with-banner');
    } else {
      backMyOffersLink.classList.remove('with-banner');
    }
  }
};

export default function () {
  const BANNER_TYPE = {
    TAKE_CONTROL: 'TakeControl',
    MAINTENANCE: 'Maintenance',
  };
  const banners = [];

  if (UserAuth.isImpersonated()) {
    banners.push(BANNER_TYPE.TAKE_CONTROL);
  }

  if (window?.MAINTENANCE) {
    banners.push(BANNER_TYPE.MAINTENANCE);
  }

  if (banners.length) {
    const header = document.querySelector('body > header');
    const section = document.createElement('section');
    section.id = 'banner';
    section.classList.add('banner');

    const boxShadow = document.createElement('div');
    boxShadow.classList.add(`banners-box-shadow`);

    const resizeBoxShadow = () => {
      if (document.querySelector('#search-app')) {
        /**
         * Intensive scrolling on WebKit creates a 1px gap between the top and the banner/filters.
         * To fix this, we decrease the new "top" position by 1
         * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-4830
         */
        // Increase Criterion Bar top position
        const querySelectorCriterionBar = document.querySelector('.criterion-bar');
        querySelectorCriterionBar.style.top = `${section.getBoundingClientRect().height - 1}px`;
        // Increase Search Map top position
        const querySelectorSearchMap = document.getElementById('search-criterion-bar');
        querySelectorSearchMap.style.top = `${section.getBoundingClientRect().height - 1}px`;

        // Set header and criterion bar visible on Take Control
        if (!isMobileOrTablet() && UserAuth.isImpersonated()) {
          const querySelectorHeader = document.querySelector('#header');
          if (querySelectorHeader) {
            querySelectorHeader.style.top = `${section.getBoundingClientRect().height - 1}px`;
            querySelectorHeader.style.position = 'sticky';
            querySelectorSearchMap.style.top = `${querySelectorHeader.getBoundingClientRect().height + section.getBoundingClientRect().height - 1}px`;
            querySelectorSearchMap.style.position = 'sticky';
          }
        }
      } else {
        // Set header top position
        const querySelectorHeader = document.querySelector('#header');
        if (querySelectorHeader) {
          querySelectorHeader.style.top = `${section.getBoundingClientRect().height}px`;
        } else {
          // When no header is displayed (initialize/reset password form)
          const querySelectorHeaderLogo = document.querySelector('.header__logo');
          if (querySelectorHeaderLogo) {
            querySelectorHeaderLogo.style.marginTop = `${section.getBoundingClientRect().height}px`;
          }
        }

        const querySelectorHeroHome = document.querySelector('.home-hero');
        if (!querySelectorHeroHome || isMobileOrTablet()) {
          // Increase Sticky Details top position
          const sectionHeight = Math.max(0, section.getBoundingClientRect().height);
          // Increase empty box-shadow div
          boxShadow.style.paddingTop = `${sectionHeight}px`;
        } else {
          boxShadow.style.paddingTop = '0px';
        }
        if (document.getElementById('banner') && document.getElementById('gallery')) {
          const sectionHeight = Math.max(0, section.getBoundingClientRect().height);
          document.querySelectorAll('.banner-scroll-margin').forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.style['scroll-margin-top'] = `${SCROLL_MARGIN_BASE + sectionHeight}px`;
          });
        }
        const headerHeight = 64;
        const wrapperHome = document.querySelector('.wrapper.home');
        if (wrapperHome) {
          const sectionHeight = Math.max(0, section.getBoundingClientRect().height);
          wrapperHome.style.marginTop = isMobileOrTablet() ? '0px' : `${sectionHeight + headerHeight}px`;
        }
      }

      const selectors = [ '#g_id_onload', '.search-app-columns-container' ];
      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          element.classList.add('banner-margin');
        }
      });
    };

    banners.forEach((boxType) => {
      const bannerType = boxType.toLowerCase();

      const div = document.createElement('div');
      div.classList.add('banner__container', `banner__container--${bannerType}`);

      const user = UserAuth.getUser();
      const impersonnatedUserDisplayedData = user ? `${user.firstname} ${user.lastname} - ${user.organization.name}` : '';

      const p = document.createElement('p');
      p.innerHTML = translations.messages[`banner.${bannerType}.message`].replace('%user%', impersonnatedUserDisplayedData);

      const button = document.createElement('div');
      button.classList.add('closeButton');

      if (boxType === BANNER_TYPE.TAKE_CONTROL) {
        const link = document.createElement('a');
        link.href = '/logout';

        const divInA = document.createElement('div');
        divInA.innerHTML = translations.messages['global.disconnect'];

        link.appendChild(divInA);
        button.appendChild(link);
      }

      div.appendChild(p);
      div.appendChild(button);
      section.classList.add(`banner-${bannerType}`);
      section.appendChild(div);
      document.body.insertBefore(section, header);
    });

    const page = document.querySelector('.page');

    if (page && !UserAuth.isLoggedIn()) {
      page.style.marginTop = `${header.getBoundingClientRect().height}px`;
    }

    resizeBoxShadow();
    adjustEditOffer();
    document.body.insertBefore(boxShadow, section);

    window.addEventListener('load', () => {
      // later redraw may change the upper section height
      // @see https://bureaux-a-partager.atlassian.net/browse/MATCH-4910
      resizeBoxShadow();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      adjustEditOffer();
      resizeTimer = setTimeout(resizeBoxShadow, 50);
    });
  }
}
